import React from 'react';
import BEMHelper from 'react-bem-helper';

const c = new BEMHelper('Button');

export interface ButtonProps
    extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'color'> {
    color?: 'success';
    outline?: boolean;
    primary?: boolean;
    block?: boolean;
}

const Button: React.FC<ButtonProps> = ({
    children,
    color,
    outline = false,
    primary = false,
    block = false,
    className,
    ...rest
}) => (
    <button
        {...rest}
        {...c(undefined, { outline, primary, block, success: color === 'success' }, className)}
    >
        {children}
    </button>
);

export default Button;
